import EnterpriseSSOExperiments from 'bundles/epic/clients/__generated__/EnterpriseSSO';

export const isForcedSSOLoginFlowEnabled = () => EnterpriseSSOExperiments.get('enableForceSsoLoginV2Beta');
